import axios from 'axios';
import config from '@/config/env-constants';

export default {

    getDashboard(currUserId, filterBy) {
        let url = `${config.cloudFunctionsBaseUrl}/getDashboard`;
        return axios.post(url, {
            currUserId: currUserId,
            filterBy: JSON.stringify(filterBy)
        });
    }
}